import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";

export const useRiskAndCompliance = () => {
    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingRiskAndCompliance>();

    const formProps: HighRiskMerchant.RiskAndCompliance.OnboardingRiskAndComplianceForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.RiskAndCompliance.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: () => {
            alert('Not implemented yet please wait for the update.');
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.RiskAndCompliance.useForm(formProps),
        ...data
    };
};

export default useRiskAndCompliance;
